// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// CompanySizeBand — source: shared/config/company_size_band.config.json

export const COMPANY_SIZE_BAND_VALUES = ["solo", "micro", "small", "medium", "large", "enterprise"] as const;
export type CompanySizeBand = (typeof COMPANY_SIZE_BAND_VALUES)[number];

export const companySizeBandDefaultVisibilityMode: Record<CompanySizeBand, "everyone" | "owner_and_shared"> = {
  "solo": "everyone",
  "micro": "everyone",
  "small": "everyone",
  "medium": "owner_and_shared",
  "large": "owner_and_shared",
  "enterprise": "owner_and_shared",
};

